import { responseOne } from "./tatResponseP1";
import { responseTwo } from "./tatResponseP2";
import { responseThree } from "./tatResponseP3";
import { responseFour } from "./tatResponseP4";
import { responseFive } from "./tatResponseP5";
import { responseSix } from "./tatResponseP6";
import { responseSeven } from "./tatResponseP7";
import { responseEight } from "./tatResponseP8";
import { responseNine } from "./tatResponseP9";
import { responseTen } from "./tatResponseP10";

export const responses = {
  one: responseOne,
  two: responseTwo,
  three: responseThree,
  four: responseFour,
  five: responseFive,
  six: responseSix,
  seven: responseSeven,
  eight: responseEight,
  nine: responseNine,
  ten: responseTen,
};
